<template>
	<div class="container">
		<LoadingScreen v-if="this.show.loading" />
		<ModalAlert id="esqueci-senha" @close="$router.replace('/')">
			<DynamicIcon icon="check" :classString="'alert-exclamation'"/>
			Foi enviado um e-mail com um link para redefinir sua senha, por
			favor verifique sua caixa de e-mail.
		</ModalAlert>

		<div class="row align-self-center justify-content-center initial-div-right-father">
			<div class="col-5" id="initial-img-left"></div>
			<div class="col-7" id="initial-div-right">
				<div id="initial-sub-div-right">
					<div id="logo">
						<img src="@/assets/optum-logo.svg" />
					</div>
					<div class="alterar-senha">
						<img class="icon" src="@/assets/Icon_ArrowCircle.svg"/>
						<b id="indicators-initial">Alterar senha</b>
					</div>

					<b-form class="mb-2 animate__fadeInUp">

						<div class="mt-3 animate__fadeInUp" v-if="show.email">
							<label class="d-block">Para definir sua senha, informe o login (e-mail) da sua conta.</label
							>
							<InputConfirmEmail
								v-model="email"
								:validation-message="validation.email"
								@change="validation.error = null"
							/>
						</div>

						<div class="group-btn">
							<b-button pill class="btn-base outline-primary-btn optum-bold" @click="back" >Voltar</b-button>
							<b-button pill class="btn-base primary-btn optum-bold" @click="next">Enviar</b-button>
						</div>
					</b-form>

					<b-badge
						class="mb-3 mt-4"
						variant="danger"
						v-if="validation.error"
						style="white-space: break-spaces; min-width: 100%">
						{{ validation.error }}
					</b-badge>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputConfirmEmail from "./components/InputConfirmEmail.vue";
import LoadingScreen from "@/components/commons/LoadingScreen.vue";
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ModalAlert from "../../commons/ModalAlert.vue";
import UserResource from "@/resources/UserResource.js";
import Validations from "@/util/Validations";

let emptyValidations = {
	email: null,
	cpf: null,
	error: null,
}

export default {
	name: "EsqueciSenha",
	components: {
		DynamicIcon,
		InputConfirmEmail,
		LoadingScreen,
		ModalAlert,
	},
	data() {
		return {
			email: null,
			cpf: null,
			validation: { ...emptyValidations },
			show: {
				email: true,
				form: true,
				loading: false,
			},
			emailHint: "",
		};
	},
	computed: {
		cpfNumbers() {
			return this.cpf && this.cpf.replace(/\D+/g, "");
		},
	},
	methods: {
		next() {
			if (this.show.email == false) {
				this.fillEmailHint();
			} else if (this.show.email == true) {
				this.askRedefinePassword();
			}
		},
		askRedefinePassword() {
			this.validation.email = Validations.email(this.email, true);

			if (this.validation.email) {
				return;
			}

			this.show.loading = true;

			UserResource.askRedefinePassword(this.cpfNumbers, this.email)
				.then(() => {
					this.$bvModal.show("esqueci-senha");
					this.validation.email = null;
				})
				.catch((response) => {
					this.validation.error = Validations.getHttpFieldMessage(
						response,
						"email",
						"E-mail "
					);

					this.validation.error = Validations.getHttpFieldMessage(
						response,
						"cpf",
						"Email "
					);
					
				})
				.then(() => {
					this.show.loading = false;
				});
		},
		back() {			
			this.$router.replace("/");
			this.validation.error = null
			this.validation.cpf = null;
		},
		fillEmailHint() {
			this.validation = { ...emptyValidations }

			this.validation.cpf = Validations.cpf(this.cpf, true);

			if (this.validation.cpf) {
				return;
			}

			this.show.loading = true;

			UserResource.getEmailHint(this.cpfNumbers)
				.then((hint) => {
					this.emailHint = `${hint.start}••••••${hint.end}`;
					this.show.email = true;
					this.validation.error = null
				})
				.catch((response) => {
					this.validation.error = Validations.getHttpFieldMessage(
						response,
						"cpf",
						""
					);

					if (!this.validation.cpf) {
						this.validation.cpf = Validations.getHttpMessage(
							response,
							"Erro: "
						);
					}
				})
				.then(() => {
					this.show.loading = false;
				});
		},
		validateCPF(cpf, forceUpdate = true) {
			this.validation.cpf = Validations.cpf(cpf, true) || null; // "" will show green flag for this input

			if (forceUpdate) {
				this.$forceUpdate();
			}
		}
	}
};
</script>

<style scoped lang="scss">
div.container {
	margin: 0px;
	max-width: 100vw;
}
.alterar-senha {
	display: flex;
	justify-content: flex-start;
	align-items:flex-start;
	gap: 15px;
}

.initial-div-right-father{
	background-color: $screenBgColor;
}

.icon {
  width: 32px;
  margin-right: 0 6% 0 0;
}

#initial-sub-div-right {
	width: 60%;
}

#indicators-initial {
	border-bottom: #002677 solid 3px;
	color: #002677 !important;
	width:105px;
}

#indicators-initial b {
	color: #002677 !important;
	font-weight: 600;
}

#indicators-initial:hover {
  border-bottom: #FF612B solid 3px;
}

#indicators-initial b:hover {
  color: #FF612B !important;
}

#input-CPF label {
	text-align: justify !important;
}

.group-btn {
	display: flex;
	justify-content: flex-end;
	gap: 10px;
}

html body .group-btn button{
	font-size: 16px !important;
	font-weight: 800 !important;
}

.b-icon-envelope {
	color: #b1b3b2;
	width: 3em;
	height: 3em;
	margin-bottom: 10px;
}

@media (max-width: 930px) {
	.group-btn {
		justify-content: space-between;
	}

	.group-btn button {
		width: 45% !important;
	}
}
</style>